import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndividualbasicinfoComponent } from './individualbasicinfo/individualbasicinfo.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  exports: [IndividualbasicinfoComponent],
  declarations: [IndividualbasicinfoComponent],
  imports: [
    CommonModule,FormsModule,
    SharedModule,
  ]
})
export class IndividualmanagementModule { }

// translation loader moved to SharedModule

